module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./create.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/create.md
// module id = 1KUt
// module chunks = 0